import * as React from 'react';

export const invokeRefFunction = (refObject: React.MutableRefObject<(() => void) | undefined>) => {
  if (typeof refObject.current === 'function') {
    refObject.current();
  }
};
